import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Checkbox, Container, FormControlLabel, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputLabel, Input, Dialog } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux'
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/inPlaySlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { CANCEL_IN_PLAY, CANCEL_IN_PLAY_USER, CHANGESTATUS, FORCE_CANCEL_IN_PLAY, GET_FANTASY_POINTS, GET_IN_PLAY_USER_ANALYTICS, GET_MATCH_NAME, INPLAY, INPLAY_CHANGE_ALL_STATUS, IN_PLAY_JOINED_SLOTS, MAKE_GST_DATA, RATE_DATA, SUSPENDINPLAY, WINNING_DISTRIBUTION_IN_PLAY, WINNING_SET_IN_PLAY, WINNING_SET_PASSWORD } from '../../constant/endpoint';
import { PREDICTION_TYPE_GST, useStyles } from '../../constant/constant';
import PredictionNvigation from '../../components/PredictionNvigation';
import { SuspendInPlay } from './suspendInPlay';
import { mkConfig, generateCsv, download } from "export-to-csv";
import {  decryptPassword } from '../../helper';
import { CircularProgress } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '95%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};


const InPlay = () => {
    const { match_id, series_id, sport } = useParams()
    const [open, setOpen] = React.useState(false);
    const [InPlaylist, setInPlayList] = React.useState([]);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [sort, setSort] = React.useState({});
    const [matchId, setMatchId] = React.useState({});
    const [Loading, setLoading] = React.useState(false);
    const [apiWork, setApiWork] = React.useState(false);
    const [pointsData, setPointsData] = React.useState({})
    const [isOpenSuspend, setIsOpenSuspend] = React.useState(false)
    const [circularLoader, setCircularLoader] = React.useState(false)
    const classes = useStyles();
    const navigate = useNavigate();
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        setOpen(true)
        dispatch(stateRefresh())
        setApiWork(false)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch();
    const predictionState = useSelector((state) => state.inPlaySlice);

    useEffect(() => {
        getOpinionTrading()
        getMatchName()
    }, [])

    const getMatchName = async () => {
        const result = await axios.get(GET_MATCH_NAME.replace(':match_id', match_id))
        if (result?.data?.status === 'success') {
            setMatchId(result?.data?.data)
        }
    }
    const getOpinionTrading = async () => {
        const response = await axios.get(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id))
        setLoading(true)
        if (response?.data?.status) {
            setInPlayList(response.data.data)
            setLoading(false)
        }
    }

    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }
    const removeOption = (index) => {
        const options = predictionState.questionStates.option.filter((data, i) => i !== index)
        dispatch(stateValues({ name: 'option', value: options }))
    }
    const selectCorrectAnswer = (e) => {
        const option = predictionState.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }
    const addOptionFiled = () => {
        if (!isEmpty(predictionState.questionStates.question_english)) {
            dispatch(stateValues({ name: 'option', value: [...predictionState.questionStates.option, { option: '', isCorrect: false, }] }))
        } else {
            getSweetAlert('error', 'fill Question in English field')
        }
    }
    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const setOption = (e, index) => {
        const { name, value } = e.target;
        const selectedOption = predictionState.questionStates.option.find((data, i) => i === index)
        let option = [...predictionState.questionStates.option]
        console.log(option);
        const data = {
            ...selectedOption,
            id: index + 1,
        }
        data[name] = value
        option[index] = data
        dispatch(stateValues({ name: 'option', value: option }))
    }

    const submit = async () => {
        if (IsValidation()) {
            setApiWork(true)
            await submitQuestion()
        }
    }

    const submitQuestion = async () => {
        const formData = new FormData()
        let data = {
            ...predictionState.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(predictionState.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(predictionState.questionStates.predic_end_time).utc().format(),
            under_runs: predictionState.questionStates.over_runs - predictionState.questionStates.difference
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        delete data.status
        let result;
        if (predictionState.questionStates.isEdit) {
            result = await axios.patch(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        }
        if (result?.data?.status === 'success') {
            setApiWork(false)
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
        handleClose()
    }
    const IsValidation = () => {

        let status = true
        const data = predictionState.questionStates
        console.log("predictionState.questionStates.over_runs1", (data.is_over_under && ((data.over_runs < 10) || (data.over_runs > 999))));

        console.log(!(predictionState.questionStates.for_favourite_team));
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (!(data.entry_fee > 0)) {
            status = false
            getSweetAlert('error', 'Entry Free  Required')
        } else if (data.opening_expected_winning_amount <= 0) {
            status = false
            getSweetAlert('error', 'Opening Expected winning Must be greater than 0 ')
        } else if ((data.minimum_winning_amount < 8) || (data.minimum_winning_amount > 19)) {
            status = false
            getSweetAlert('error', 'Minimum Winning Must be between 8 to 20')
        } else if (predictionState.questionStates.for_favourite_team === 'false' && predictionState.questionStates.is_over_under == false  && (!(data.join_slot_limit > 0) || (+data.join_slot_limit > +data.slots_per_user))) {
            status = false
            getSweetAlert('error', 'Join Slot Limit Not more than User slot')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        } else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')
        } else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (Number(data.slots_per_user) >= Number(data.slots)) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than Total Slots')
        }
        else if (Number(data.slots) > 1000000) {
            status = false
            getSweetAlert('error', 'Total slots not be more than 10 lakh')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        } else if (!data.is_over_under && (data.option.some(data => isEmpty(data.option)) || data.option.length < 2)) {
            status = false
            getSweetAlert('error', 'Option must be Filled and minimum two option required')
        } else if ((predictionState.questionStates.fixed_winning === 'false' || predictionState.questionStates.fixed_winning === false) && (predictionState.questionStates.for_favourite_team) === 'false' && data.option.some(data => !(data.option_open_amount > 0))) {
            status = false
            getSweetAlert('error', 'Option Open Amount must be Filled')
        } else if (predictionState.questionStates.for_favourite_team === 'true' && (!(predictionState?.questionStates?.option[0].hasOwnProperty('team_id')) || !(predictionState?.questionStates?.option[1].hasOwnProperty('team_id')))) {
            console.log(predictionState.questionStates.for_favourite_team);
            status = false
            getSweetAlert('error', 'Option team name required')
        } else if (predictionState.questionStates.for_favourite_team === 'true' && predictionState?.questionStates?.option[0].team_id === predictionState?.questionStates?.option[1].team_id) {
            status = false
            getSweetAlert('error', 'Option team name must be diffrent')
        } else if (getPollsOptionCheck(data)) {
            status = false
            getSweetAlert('error', 'option must be diffrent')
        } else if ((predictionState.questionStates.fixed_winning === 'true' || predictionState.questionStates.fixed_winning === true) && Number(predictionState.questionStates.id) < 1) {
            status = false
            getSweetAlert('error', `please fill the ${predictionState.questionStates.id_type} id field`)
        }
        else if (data.is_over_under && ((Number(data.over_runs) > 999))) {
            status = false
            getSweetAlert('error', 'Over Runs should be less than 999')
        }
        else if (data.is_over_under && ((Number(data.over_runs) - Number(data.difference)) < 1 )) {
            status = false
            getSweetAlert('error', 'Under Runs should be atleast 1')
        }
        return status
    }
    const getPollsOptionCheck = (data) => {
        const option = data.option
        const oldArr = []
        option.map((item) => oldArr.push(item.option))
        var unique = [...new Set(oldArr)]
        function arrayEquals(a, b) {
            return Array.isArray(unique) &&
                Array.isArray(b) &&
                a.length === b.length &&
                a.every((val, index) => val === b[index]);
        }
        return !arrayEquals(oldArr, unique)
    }
    const editQuestion = (data) => {
        const inPlayData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(inPlayData));
        setOpen(true)
        getOpinionTrading()
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'QUIZ PLAY'}</h5>
    ];

    const questionStatus = async (status, _id, predInfo) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id, _id }
        } else {
            data = { status: 1, match_id, series_id, _id }
        }
        if (data.status === 1 && predInfo.is_over_under && predInfo.over_runs <= 0) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Please Enter Over Runs",
                showConfirmButton: false,
                timer: 1500,
            });
            return;
        }
        await axios.post(CHANGESTATUS, data)
        getOpinionTrading()
    }
    const suspendQuestion = async (data, _id) => {
        // let data;
        // if (suspend) {
        //     data = { suspend: "false", match_id, series_id, _id }
        // } else {
        //     data = { suspend: "true", match_id, series_id, _id }
        // }

        // await axios.post(SUSPENDINPLAY, data)
        // getOpinionTrading()


        const inPlayData = {
            ...data,
            openSuspend: true,
        };
        dispatch(setEditQuestion(inPlayData));
        // setIsOpenSuspend(true)
        if (data.for_favourite_team == true) {
            window.location = `/matchlist/in_play/${match_id}/${series_id}/${data.sport}/${data._id}/suspend/contest`
        }
        else
            window.location = `/matchlist/in_play/${match_id}/${series_id}/${data.sport}/${data._id}/suspend`
        getOpinionTrading()
    }

    
    const tradingCancel = async (data, prediction_id) => {
        if (data.is_over_under == true) {
            tradingCancelForOverUnder(data, prediction_id)
            return;
        }
        const answer = data.option.filter(x => x.isCorrect)[0].option
        let optionObj = {
            "Select answer": "Select answer"
        };
        for (var obj of data.option) {
            optionObj[obj.option] = obj.option
        }
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'select',
            inputOptions: optionObj,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (login) => {
                if (login.trim() !== answer.trim()) {
                    getSweetAlert('error', 'Please Correct Answer')
                } else {
                    const data = {
                        prediction_id,
                        match_id,
                    }
                    await axios.post(CANCEL_IN_PLAY, data)
                    getOpinionTrading()
                }
            }
        })
    }
    const tradingCancelForOverUnder = async (data, prediction_id) => {
        const answer = data.correct_answer;
        console.log("answer", answer);
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'number',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (login) => {
                console.log("test", login, answer);
                if (Number(login.trim()) !== Number(answer)) {
                    getSweetAlert('error', 'Please Enter Correct Answer')
                } else {
                    const data = {
                        prediction_id,
                        match_id,
                    }
                    await axios.post(CANCEL_IN_PLAY, data)
                    getOpinionTrading()
                }
            }
        })
    }
    const tradingCancelRecord = async (data, prediction_id) => {
        Swal.fire({
            title: 'Enter Record Id',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel User',
            showLoaderOnConfirm: true,
            preConfirm: async (recordId) => {
                const resultCheck = await Swal.fire({
                    title: `Do you want to cancel slots?`,
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                })
                if (resultCheck.isConfirmed) {
                    const data = {
                        prediction_id,
                        match_id,
                    }
                    const response = await axios.post(CANCEL_IN_PLAY_USER.replace(":recordId", recordId), data)
                    if (response?.data?.status === 'Success') {
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "User's Slots Cancelled successfully!",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                       
                    }
                    else {
                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: response?.data?.message || "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                    getOpinionTrading()
                }
            }
        })
    }
    const setWinning = async (data) => {
        if (data.is_over_under == true) {
            setWinningForOverUnder(data)
            return;
        }
        const resultCheck = await Swal.fire({
            title: `Do you want Set Winning?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are set the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })

            const trade_id = data._id
            // const result = await axios.post(`${apiBaseUrl}/set_winning_inplay`,{"prediction_id":id,"match_id":match_id, "sport":1}); 
            const optionAnser = data.option
            const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            const bodyData = {
                match_id: match_id,
                prediction_id: trade_id,
                option_id: isCorrectId,
                sport: 1,
            }
            const response = await axios.post(WINNING_SET_IN_PLAY, bodyData)
            if (response?.data?.status === 'Success') {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Set Winning successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                });
                Swal.close()
               
            }
            else {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: response?.data?.message || "Something Went Wrong",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            getOpinionTrading()
        }
    };
    const setWinningForOverUnder = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Set Winning?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are set the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })

            const trade_id = data._id
            const bodyData = {
                prediction_id: trade_id,
            }
            const response = await axios.post(WINNING_SET_IN_PLAY, bodyData)
            if (response?.data?.status !== 'Success') {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: response?.data?.message || "Something Went Wrong",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
else {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Set Winning successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            getOpinionTrading()

        }
        
    }
    const winningDistribution = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are set the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const trade_id = data._id
            // const result = await axios.post(`${apiBaseUrl}/set_winning_inplay`,{"prediction_id":id,"match_id":match_id, "sport":1}); 
            const bodyData = {
                match_id: match_id,
                prediction_id: trade_id,
                sport: 1,
            }
            const response = await axios.post(WINNING_DISTRIBUTION_IN_PLAY, bodyData)
            if (response?.data?.status !== 'Success') {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: response?.data?.message || "Something Went Wrong",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            else {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Set Winning successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            getOpinionTrading()

        }


    };
    const forceCancelPrediction = async (prediction_id) => {
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const result = await axios.post(
                FORCE_CANCEL_IN_PLAY.replace(':prediction_id', prediction_id)
            );
            if (result?.data?.status !== 'Success') {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: result?.data?.message || "Unable to force Cancel",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            if (result?.data?.status === 'Success') {
                
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Prediction Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            getOpinionTrading()
        }
    }
    const checkAnser = (data) => {
        const response = data.option.filter((data) => data.isCorrect)
        if (!isEmpty(response)) {
            return true
        }
        else {
            return false
        }
    }
    const checkData = (data) => {
        let finishData;
        let InPlayData;
        finishData = InPlaylist.filter((data) => data.is_finish)
        InPlayData = InPlaylist.filter((data) => !data.is_finish)
        if (data === 'inplay') {
            return InPlayData
        } else if (data === 'finish') {
            return finishData
        }
    }
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }
    }
    const handleShorting = async (data) => {
        // const inPlayData = {
        //     ...data,
        //     predic_start_time: `${moment(data.predic_start_time).format(
        //         "YYYY-MM-DD"
        //     )}T${moment(data.predic_start_time).format("HH:mm")}`,
        //     predic_end_time: `${moment(data.predic_end_time).format(
        //         "YYYY-MM-DD"
        //     )}T${moment(data.predic_end_time).format("HH:mm")}`,
        //     sort_number: sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        // };
        let data1 = {
            ...data
        }
        data1.sort_number = sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        delete data1.status
        const formData = new FormData()
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data1));
        let result = await axios.patch(INPLAY.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        if (result?.data?.status === 'success') {
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
    }
    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}`)
    }
    const statusActiveFun = async (status) => {
        let data = {
            match_id,
            series_id,
            status: status
        }
        const result = await axios.post(INPLAY_CHANGE_ALL_STATUS, data)
        if (result?.data?.status === "success") {
            getSweetAlert('Success', status === 1 ? " All Active QUIZ PLAY Succesfully" : "All InActive QUIZ PLAY Succesfully")
            getOpinionTrading()
        }
    }

    const getPoints = async (data) => {
        const point_type = data.id_type === 'player' ? 3 : data.id_type === 'match' ? 1 : 2
        const postData = { "point_type": point_type, "player_id": data.id, "match_id": data.match_id, "sport": data.sport, "series_id": data.series_id, "in_play_id": data._id, "admin": 1 }
        const res = await axios.post(GET_FANTASY_POINTS, postData)
        if (res?.data?.message === "success") {
            setPointsData(res?.data?.data)
        }
    }

    const getJoinedSlots = async (id) => {
        const result = await axios.get(IN_PLAY_JOINED_SLOTS.replace(':prediction_id', id))
        if (result.data.status === 'success') {
            Swal.fire({
                title: 'Joined Slots',
                text: result.data.data
            })
        }
    }

    const makeGSTData = async (match_id, series_id) => {
        const isValid = await Swal.fire({
            title: 'Do you want to Close the Match ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (isValid.isConfirmed) {
            setCircularLoader(true)
            const res = await axios.post(MAKE_GST_DATA.replace(':match_id', match_id).replace(':series_id', series_id).replace(':type', PREDICTION_TYPE_GST.QUIZ_PLAY))
            if (res.data.status === "success") {
                getSweetAlert('Success', "Match Closed Successfully")
            }
            setCircularLoader(false)
        }
    }

    const handleSuspendEnter = async (event, data) => {
        // let req = { match_id, series_id, _id:data._id, over_runs: data.over_runs, under_runs: data.over_runs - 2 }
        if (data.suspend == true && event.key !== "Enter") {
            event.preventDefault();
        }
        if (event.key == "Enter" && data.suspend == true) {
            let req = {
                match_id, series_id, _id: data._id, suspend: "false", over_runs: data.over_runs, under_runs: data.over_runs - data.difference
            }
            await axios.post(SUSPENDINPLAY, req)
            const inPlayData = {
                ...data,
                suspend: false,
            };
            dispatch(setEditQuestion(inPlayData));
            getOpinionTrading()
        }
        if (event.key == "Tab" && data.suspend == false) {
            updateSuspendDetails(data)
        }
    }

    const updateSuspendDetails = async (data, suspend) => {
        let req = { match_id, series_id, _id:data._id, over_runs: data.over_runs, under_runs: data.over_runs - data.difference }
            req["suspend"] = "true"
        await axios.post(SUSPENDINPLAY, req)
        const inPlayData = {
            ...data,
            suspend: true,
        };
        dispatch(setEditQuestion(inPlayData));
        getOpinionTrading()
    }

    const getUserJoinedData = async (data) => {
      
                const passResult = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', data.match_id).replace(':prediction_id', data._id))
                if(passResult.data.status === "success"){
                    Swal.fire({
                        title: `Enter Password For ${data._id}`,
                        input: 'password',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText: 'Download CSV',
                        preConfirm: async (text) => {
                            if (text == decryptPassword(passResult.data.data)) {
                                setLoading(true)
                                await callJoinedDataApi(data, data._id)  
                                setLoading(false) 
                            }else {
                                Swal.showValidationMessage('Incorrect password');
                            }
                        }               
                    })
                }
                       

    }
    const callJoinedDataApi = async (data, predictionId) => {
        const req = {
            prediction_id: predictionId,
            match_id: data.match_id,
        }
        const response = await axios.post(GET_IN_PLAY_USER_ANALYTICS, req)
        if (response?.data?.status === 'success') {
            if (!response?.data?.data?.length) {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "No Joined Data",
                    showConfirmButton: false,
                    timer: 1500,
                });
                return;
            }
            const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: `Joined Data_${predictionId}` });
            const csvParsedData = parserUserJoinedCSVData(response?.data?.data)
            const csv = generateCsv(csvConfig)(csvParsedData);
            download(csvConfig)(csv);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "CSV Downloaded!",
                showConfirmButton: false,
                timer: 1500,
            });
            Swal.close()

        }
        else {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: response?.data?.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500,
            });
        }


    }
    const getRateData = async (data) => {
     
        const response = await axios.get(`${RATE_DATA}/${data.match_id}/${data._id}`)
        if (response?.data?.status === 'success') {
            if (!response?.data?.data?.length) {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "No Joined Data",
                    showConfirmButton: false,
                    timer: 1500,
                });
                return;
            }
            const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: `Rate Data_${data._id}` });
            const csvParsedData = parserRateDataCSVData(response?.data?.data , data)
            const csv = generateCsv(csvConfig)(csvParsedData);
            download(csvConfig)(csv);
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "CSV Downloaded!",
                showConfirmButton: false,
                timer: 1500,
            });
            Swal.close()

        }
        else {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: response?.data?.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500,
            });
        }


    }

    const parserUserJoinedCSVData = (csvData) => {
        let temp = []
            let matchData = csvData;
        matchData.map((input) => {
            let obj = {
                    "Record Id": input?._id,
                    "User Id": input?.user_id,
                    "Total Slots": input?.total_slot,
                    "Expected Winning Amount": input?.expected_winning_amount,
                    "Joining Time": moment(input?.createdAt)?.format('DD/MM/YYYY, h:mm:ss A'),
                    "OptionId":input?.option_id,
                }
            if (input && input.is_over_under)
            {
                obj["runs"] = input?.runs
                obj["Option"] = input?.option_id ==1 ? "Over" : "Under"
            }
            temp.push(obj)
            })
            return temp;
    }
    const parserRateDataCSVData = (csvData,predInfo) => {
        let temp = []
            let matchData = csvData;
        matchData.map((input) => {
            let obj = {};
            if (predInfo && predInfo.is_over_under)
            {
                    obj["suspend"]= input.suspend
                    obj["over_runs"]= input.over_runs
                    obj["under_runs"] = input.under_runs
                
            }
            else {
                 obj = {
                    "favourite_team_id": input.favourite_team_id,
                    "favourite_team": input.favourite_team,
                    "line_red": input.line_red,
                    "line_green": input.line_green,
                    "line_green_add": input.line_green_add,
                    "line_red_sub": input.line_red_sub,
                    "suspend": input.suspend
                }
            }
            obj["time"]= moment(input.time)?.format('DD/MM/YYYY, h:mm:ss A')
            temp.push(obj)
            })
            return temp;
    }
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <div >
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container maxWidth="xl">
                            <Grid container style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                                <Grid item spacing={3}>
                                    <Stack className="subHomeCardHeader" spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                        <Button variant={'contained'} color="primary" onClick={() => handleOpen()}>Add Questions</Button>
                                    </Stack>
                                </Grid>
                                {/* <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} color="success" style={{ marginRight: "10px" }} onClick={() => statusActiveFun(1)}>Active All</Button>
                                            </Stack>
                                        </Grid>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} color="error" style={{ marginRight: "10px" }} onClick={() => statusActiveFun(0)}>In Active All</Button>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} color='warning' style={{ color: "black", marginRight: "10px" }} onClick={() => makeGSTData(match_id, series_id)}>Match Closed</Button>
                                            </Stack>
                                        </Grid>
                                        <PredictionNvigation match_id={match_id} series_id={series_id} sport={sport} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                        </div>
                        </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }}>
                                    <Tab label="LIVE" value="1" />
                                    <Tab label="RESULT" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel style={{ padding: "0px" }} value="1">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                {/* <TableCell align="left">Image</TableCell> */}
                                                <TableCell align="left">Question</TableCell>
                                                {/* <TableCell align="left">Slots Per User</TableCell> */}
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Sorting</TableCell>
                                                <TableCell align="center">Answer</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Suspend</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Cancel Record </TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                <TableCell align="center">Force Cancel</TableCell>
                                                <TableCell align='center'>Points</TableCell>
                                                <TableCell align='center'>Slots</TableCell>
                                                <TableCell align='center'>Get Joined Details</TableCell>
                                                <TableCell align='center'>Get Rate Details</TableCell>


                                            </TableRow>
                                        </TableHead>
                                        {circularLoader ?
                                            <div style={{ position: "absolute", left: "50%" }}>  <CircularProgress ></CircularProgress></div>
                                            :
                                            <TableBody>
                                                {InPlaylist.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? InPlaylist.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                    <TableRow style={{ background: data.shown_on_mobile ? "#e1f2e18a" : "white" }}
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        {/* <TableCell ><img alt={data.name} style={{ width: "20px" }} src={data.image} /></TableCell> */}
                                                        <TableCell style={{ width: '50%' }}>{data.question_english}</TableCell>
                                                        {/* <TableCell align="center">{data.slots_per_user}</TableCell> */}

                                                        <TableCell style={{ width: '10%' }} align="center">
                                                            {moment(data.predic_end_time).format("HH:mm")} <br></br>
                                                            {moment(data.predic_end_time).format("YYYY-MM-DD")}
                                                        </TableCell>

                                                        <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                            <Grid container style={{ display: "flex", background: '#fff' }}>
                                                                <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                                <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell>
                                                            <p>{data?.option?.filter(x => x.isCorrect)[0]?.option || (data.correct_answer !== null ? String(data.correct_answer) : "") || ""} </p>
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button></TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id, data)} >{data.status ? 'Active' : 'InActive'}</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'warning'} onClick={() => suspendQuestion(data, data._id)} disabled={((data?.is_over_under == true) || (data?.for_favourite_team == true)) ? false : true}>Go</Button>
                                                            {/* <Link variant={'contained'} size={'small'} color={data.suspend ? 'info' : 'error'} to={`/matchlist/in_play/${match_id}/${series_id}/${data.sport}/${data._id}/suspend`} disabled={data?.is_over_under == true ? false : true}>Edit</Link> */}

                                                        </TableCell>


                                                        <TableCell align='center'>
                                                            {
                                                                (data.status === 0 && data.option.some(x => x.isCorrect) || (data.is_over_under == true && data.correct_answer !== null && String(data.correct_answer))) &&
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data, data._id)}>Cancel</Button>
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancelRecord(data, data._id)}>Cancel Slot</Button>
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                (data.is_prediction_full || data.pred_confirm || data.is_pred_cancel) && !data.win_distribute && (checkAnser(data) || (data.is_over_under == true && data.correct_answer !== null && String(data.correct_answer))) && <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)}>Set</Button>
                                                            }
                                                            {
                                                                data.is_winning_set ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data)}>Distribute</Button> : ''
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={data.status === 0 ? false : true}>Force Cancel</Button></TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => getPoints(data)} disabled={!JSON.parse(data.fixed_winning)}>Get</Button></TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => getJoinedSlots(data._id)} >Check</Button></TableCell>
                                                        <TableCell align='center'><Button variant='contained' color={'secondary'} size="small" onClick={() => getUserJoinedData(data)}>Get Data</Button></TableCell>
                                                        <TableCell align='center'><Button variant='contained' sx={{ backgroundColor: '#814a01'}}  size="small" onClick={() => getRateData(data)}>Rate Data</Button></TableCell>
                                                    </TableRow>
                                                )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                            </TableBody>
                                        }
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                            <TabPanel style={{ padding: "0px" }} value="2">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="left">Slots Per User</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">View</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                <TableCell align="center">Force Cancel</TableCell>
                                                <TableCell align='center'>Points</TableCell>
                                                <TableCell align='center'>Slots</TableCell>
                                                <TableCell align='center'>Get Joined Details</TableCell>
                                                <TableCell align='center'>Get Rate Details</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {checkData('finish').length > 0 ? checkData('finish')?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell align="center">{data.slots_per_user}</TableCell>
                                                    <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>View</Button></TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={data.status ? 'info' : 'error'} disabled onClick={() => questionStatus(data.status, data._id)} >{data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data._id)} disabled>Cancel</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            (data.is_prediction_full || data.pred_confirm || data.is_pred_cancel) && !data.win_distribute && checkAnser(data) && <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)} disabled>Set</Button>
                                                        }
                                                        {
                                                            data.is_winning_set ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data)} disabled>Distribute</Button> : ''
                                                        }
                                                    </TableCell>
                                                    {
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={data.win_distribute ? true : false}>Force Cancel</Button></TableCell>
                                                    }
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => getPoints(data)} disabled={!JSON.parse(data.fixed_winning)}>Get</Button></TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => getJoinedSlots(data._id)} >Check</Button></TableCell>
                                                    <TableCell align='center'><Button variant='contained' color={'secondary'} size="small" onClick={() => getUserJoinedData(data)}>Get Data</Button></TableCell>
                                                    <TableCell align='center'><Button variant='contained' sx={{ backgroundColor: '#814a01'}}  size="small" onClick={() => getRateData(data)}>Rate Data</Button></TableCell>

                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>

            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'QUIZ PLAY'}  Questions</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        <Grid xs={4} item>
                            <label>Entry Fee</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'entry_fee'} onChange={setQuestion} value={predictionState.questionStates.entry_fee} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Total Slots</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots'} onChange={setQuestion} value={predictionState.questionStates.slots} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Slots Per User</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={setQuestion} value={predictionState.questionStates.slots_per_user} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Admin Per Commission</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={predictionState.questionStates.admin_commission} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Opening Expected Winning</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'opening_expected_winning_amount'} onChange={setQuestion} value={predictionState.questionStates.opening_expected_winning_amount} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        {/* <Grid container ml={1} mt={1}>
                            <Grid xs={6} item>
                                <label>Start Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>End Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion} disabled={predictionState.questionStates.is_finish} />
                            </Grid>
                        </Grid> */}
                        <Grid container ml={1} mt={1}>
                            <Grid xs={6} item>
                                <label>Start Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={predictionState.isEdit === true ? true : false} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>End Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish")} />
                            </Grid>
                        </Grid>
                        {!(JSON.parse(predictionState.questionStates.is_over_under)) ? <>
                            {predictionState.questionStates.fixed_winning === false || predictionState.questionStates.fixed_winning === 'false' ? <>
                                <Grid xs={6} item>
                                    <label>Minimum Winning Amount</label>
                                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'minimum_winning_amount'} onChange={setQuestion} value={predictionState.questionStates.minimum_winning_amount} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                </Grid>
                                <Grid xs={6} item>
                                    <label>Maximum Winning Amount</label>
                                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'maximum_winning_amount'} onChange={setQuestion} value={predictionState.questionStates.maximum_winning_amount} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                </Grid></> : <><Grid xs={4} item>
                                    <label>Fixed Amount</label>
                                    <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'fixed_winning_amount'} onChange={setQuestion} value={predictionState.questionStates.fixed_winning_amount} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                </Grid>
                                <Grid xs={4} item>
                                    <label>Id Type</label>
                                    <TextField
                                        value={predictionState.questionStates.id_type}
                                        onChange={setQuestion}
                                        size={'small'}
                                        name='id_type'
                                        select // tell TextField to render select
                                        fullWidth
                                        disabled={predictionState.questionStates.isEdit === true ? true : false}
                                    >
                                        <MenuItem key={1} value="match">
                                            Match
                                        </MenuItem>
                                        <MenuItem key={2} value="player">
                                            Player
                                        </MenuItem>
                                        <MenuItem key={3} value="team">
                                            Team
                                        </MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid xs={4} item>
                                    <label>Id</label>
                                    <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'id'} onChange={setQuestion} value={predictionState.questionStates.id} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                </Grid>
                            </>
                            }
                        </> : " "}
                        <Grid xs={3}>
                            <FormControlLabel control={<Checkbox defaultChecked={JSON.parse(predictionState.questionStates.pred_confirm)} value={!JSON.parse(predictionState.questionStates.pred_confirm)} onChange={setQuestion} name={'pred_confirm'} />} label="Prediction Confirm" disabled={predictionState.questionStates.isEdit === true ? true : false} />
                        </Grid>
                        <Grid xs={3}>
                            <FormControlLabel control={<Checkbox defaultChecked={JSON.parse(predictionState.questionStates.is_global)} value={!JSON.parse(predictionState.questionStates.is_global)} onChange={setQuestion} name={'is_global'} />} label="Is Global" />
                        </Grid>
                        <Grid xs={3}>
                            {((predictionState.questionStates.fixed_winning === false || predictionState.questionStates.fixed_winning === 'false') && !JSON.parse(predictionState.questionStates.is_over_under) ) &&
                                <FormControlLabel control={<Checkbox defaultChecked={JSON.parse(predictionState.questionStates.for_favourite_team)} value={!JSON.parse(predictionState.questionStates.for_favourite_team)} onChange={setQuestion} name={'for_favourite_team'} />} label="Contest Type" disabled={predictionState.questionStates.isEdit === true ? true : false} />
                            }
                        </Grid>
                        <Grid xs={3}>
                            {((predictionState.questionStates.for_favourite_team === 'false' || predictionState.questionStates.for_favourite_team === false) &&  !JSON.parse(predictionState.questionStates.is_over_under) )&&
                                <FormControlLabel control={<Checkbox defaultChecked={JSON.parse(predictionState.questionStates.fixed_winning)} value={!JSON.parse(predictionState.questionStates.fixed_winning)} onChange={setQuestion} name={'fixed_winning'} />} label="Fixed Winning" disabled={predictionState.questionStates.isEdit === true ? true : false} />
                            }
                        </Grid>
                        <Grid xs={6} container>
                            {!JSON.parse(predictionState.questionStates.fixed_winning) && !JSON.parse(predictionState.questionStates.for_favourite_team) ?
                                <FormControlLabel control={<Checkbox defaultChecked={JSON.parse(predictionState.questionStates.is_over_under)} value={!JSON.parse(predictionState.questionStates.is_over_under)} onChange={setQuestion} name={'is_over_under'} />} label="Is Over Under" disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                    : ""}
                        </Grid>
                        <Grid xs={6} container>
                            {JSON.parse(predictionState.questionStates.is_over_under) ?
                                <>
                                 <label>Difference</label>
                                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'difference'} onChange={setQuestion} value={predictionState.questionStates.difference} disabled={predictionState.questionStates.status === 1 } />
                                 </>
                                    : ""}
                        </Grid>

                        {!JSON.parse(predictionState.questionStates.is_over_under) ?
                            <>
                       
                                {((predictionState.questionStates.for_favourite_team === 'false' || predictionState.questionStates.for_favourite_team === false)) &&
                                    <Grid xs={6} item>
                                        <label>Join Slot Limit</label>
                                        <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'join_slot_limit'} onChange={setQuestion} value={predictionState.questionStates.join_slot_limit} disabled={predictionState.questionStates.isEdit === true ? true : false} />
                                    </Grid>
                                }
                            </> : ""}
                        {(predictionState.questionStates.fixed_winning === 'true' || predictionState.questionStates.fixed_winning === true) &&
                            <Grid xs={6} item>
                                <label>Extra Points</label>
                                <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'extra_points'} onChange={setQuestion} value={predictionState.questionStates.extra_points} />
                            </Grid>
                        }
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in English</label>
                            <TextField fullWidth id="english" size={'small'} placeholder="Write Question in English" name={'question_english'} value={predictionState.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={predictionState.questionStates.is_finish || get(predictionState, "questionStates.status") === 1} />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in Hindi</label>
                            <TextField fullWidth id="hindi" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={predictionState.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={predictionState.questionStates.is_finish || get(predictionState, "questionStates.status") === 1} />
                        </Grid>
                        {!JSON.parse(predictionState.questionStates.is_over_under) ?
                            <>
                                {predictionState.questionStates.option.map((data, index) =>
                                    <Grid container mt={1} item spacing={1}>
                                        <Grid item ><TextField size={'small'} placeholder={`option ${index + 1}`} value={data.option} name={'option'} onChange={(e) => setOption(e, index)} disabled={predictionState.questionStates.status === 1 || predictionState.questionStates.is_finish ? true : false} />
                                        </Grid>
                                        {
                                            predictionState.questionStates.for_favourite_team === 'true' || (predictionState.questionStates.isEdit && predictionState.questionStates.for_favourite_team) ?
                                                <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '40%' }} style={{ margin: '0px' }}>
                                                    <Select style={{ margin: '10px' }} type='select' id="demo-simple-select-label" name={'team_id'} value={predictionState.questionStates.option.find(x => x.team_id === data.team_id).team_id} onChange={(e) => setOption(e, index)} disabled={predictionState.questionStates.status === 1 || predictionState.questionStates.is_finish ? true : false}>
                                                        <MenuItem value={matchId.localteam_id}>{matchId.localteam}</MenuItem>
                                                        <MenuItem value={matchId.visitorteam_id}>{matchId.visitorteam}</MenuItem>
                                                    </Select>
                                                </FormControl> :
                                                <Grid item>
                                                    {(predictionState.questionStates.fixed_winning === 'false' || predictionState.questionStates.fixed_winning === false) &&
                                                        <TextField size={'small'} type='number' value={data.option_open_amount} name={'option_open_amount'} onChange={(e) => setOption(e, index)} placeholder="open amount" disabled={predictionState.questionStates.status === 1 || predictionState.questionStates.is_finish ? true : false} />
                                                    }
                                                </Grid>
                                        }
                                        <Grid item >
                                            <Button style={{ height: "80%" }} size="small" variant="outlined" color='error' onClick={() => removeOption(index)} disabled={predictionState.questionStates.isEdit === true ? true : false}>Delete</Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </> :
                            <Grid container>
                            <Grid xs={4} item mr={2}>
                                        <label>Over Runs</label>
                                        <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'over_runs'} onChange={setQuestion} value={predictionState.questionStates.over_runs}  />
                                </Grid>
                                <Grid xs={4} item>
                                        <label>Under Runs</label>
                                        <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'under_runs'}  value={ Number(predictionState.questionStates.over_runs)- Number(predictionState.questionStates.difference) >=0  ?  Number(predictionState.questionStates.over_runs)- Number(predictionState.questionStates.difference) : 0 }  />
                            </Grid>
                            </Grid>
                            }
                        <Grid item container>  
                            {!JSON.parse(predictionState.questionStates.is_over_under) ?
                                <>
                                    {
                                        predictionState.questionStates.for_favourite_team === "true" ?
                                            predictionState.questionStates.option.length < 2 && <Button variant='outlined' style={{ display: 'block', margin: '10px auto' }} onClick={addOptionFiled} disabled={predictionState.questionStates.isEdit === true ? true : false}>Add Options</Button>
                                            : predictionState.questionStates.option.length < 10 && <Button variant='outlined' style={{ display: 'block', margin: '10px auto' }} onClick={addOptionFiled} disabled={predictionState.questionStates.isEdit === true ? true : false}>Add Options</Button>
                                    }
                                </> : 
                               ""
                                }
                        </Grid>

                        <Grid item container>
                            {
                                predictionState.questionStates.isEdit && !JSON.parse(predictionState.questionStates.is_over_under) &&
                                <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                    <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                    <Select style={{ margin: '10px' }} type='select' id="demo-simple-select-label" value={get(predictionState.questionStates.option.find(data => data.isCorrect), 'id', '')} onChange={selectCorrectAnswer} disabled={predictionState.questionStates.is_finish || get(predictionState, "questionStates.status") === 1 ? true : false}>
                                        {predictionState.questionStates.option.map((data, index) =>
                                            <MenuItem value={data.id} key={index}>{data.option}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            }
                            {
                               predictionState.questionStates.isEdit && JSON.parse(predictionState.questionStates.is_over_under)    ?
                                <Grid container >
                                <Grid xs={5}>
                                        <label id="demo-simple-select-label">Please Enter Correct Answer</label>
                                <TextField type='number' name={"correct_answer"} size={"small"} onChange={setQuestion} value={predictionState.questionStates.correct_answer} style={{ marginBottom: "10px" }} disabled={(get(predictionState, "questionStates.status") === 1) || (!predictionState.questionStates.over_runs)}></TextField>
                                        </Grid>
                                
                            </Grid> : ""
                            }
                        </Grid>
                        {<>
                            <Grid xs={12}>
                                <input
                                    accept="image/*"
                                    id="contained-button-file"
                                    multiple
                                    type="file"
                                    onChange={imageFile}
                                />
                            </Grid>
                            <Grid xs={9} mt={2}>
                                <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                            </Grid>
                            <Grid xs={3} mt={2} textAlign={'right'}>
                                <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                            </Grid>
                        </>
                        }
                    </Grid>
                </Box>
            </Modal>
            <Modal
                open={!isEmpty(pointsData)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setPointsData({})}
            >
                <TableContainer component={Paper} style={{ margin: "30px auto", width: '400px' }}>
                    <Table className={classes.table} sx={{ minWidth: 300 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell><image src={pointsData?.player_image} alt='' width={200} /></TableCell>
                                <TableCell>{pointsData?.player_name}</TableCell>
                                <TableCell>{pointsData?.points}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Event</TableCell>
                                <TableCell>Actual</TableCell>
                                <TableCell>Points</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pointsData?.player_breckup?.map(data => {
                                return <TableRow>
                                    <TableCell>{data?.key_name}</TableCell>
                                    <TableCell>{data?.actual}</TableCell>
                                    <TableCell>{data?.points}</TableCell>
                                </TableRow>
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Modal>
            <SuspendDialog isOpenSuspend={isOpenSuspend} setIsOpenSuspend={setIsOpenSuspend} predictionState={predictionState} setQuestion={setQuestion} updateSuspendDetails={updateSuspendDetails} handleSuspendEnter={handleSuspendEnter}></SuspendDialog>
        </>
    )

  
}

const SuspendDialog = ({ isOpenSuspend, predictionState, setIsOpenSuspend, setQuestion, updateSuspendDetails, handleSuspendEnter }) => {

    useEffect(() => {        
    }, [predictionState.questionStates])
    return (
        <Dialog open={isOpenSuspend} >
             <center>
                <div style={{ padding: "20px 80px" }}>
                    
                <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>Suspend Question</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={()=>setIsOpenSuspend(false)}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                            </Grid>
                            <Grid item xs={12}>
                                <h4>{`Question English : ${predictionState?.questionStates?.question_english}`}</h4>
                                </Grid>
                        </Grid>
                    </Grid>
                    <hr />
               
             <Grid container style={{justifyContent:"space-between"}}>
                                <Grid xs={5} item mr={2} >
                                            <label>Over Runs</label>
                                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'over_runs'} onChange={setQuestion} value={predictionState.questionStates.over_runs} onKeyDown={(event)=>{handleSuspendEnter(event, predictionState.questionStates)}} />
                                    </Grid>
                                    <Grid xs={5} item>
                                            <label>Under Runs</label>
                                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'under_runs'}  value={predictionState.questionStates.over_runs >= predictionState.questionStates.difference ?  predictionState.questionStates.over_runs- predictionState.questionStates.difference : 0}  />
                    </Grid>
                   
                    </Grid>
                    <Grid xs={12} item mt={5}>
                    <Button variant={'contained'} size={"large"} color={predictionState.questionStates.suspend ? 'info' : 'error'}  onClick={()=>{updateSuspendDetails(predictionState.questionStates)}}>Suspend</Button>
                    </Grid>
                   
                </div>
                </center>
          
        </Dialog>
    )
}

export default InPlay